const getTableOptions = () => ({
  selectableRowsHeader: false,
  selectableRowsHideCheckboxes: true,
  elevation: 0,
  download: false,
  print: false,
  viewColumns: false,
  filter: false
})

export default getTableOptions
